<template src="../../../../components/shared/contacts/RemoveContactTemplate.html">

</template>

<script>
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "RemoveContactModal",
        props: {consultantId: {type: [Number], required: true}},
        data() {
            return {
                fullName: "",
                contactId: 0
            }
        },
        methods: {
            async showModal(contactId) {
                this.contactId = contactId;
                //Load contact Info
                let info = await api.getDataWithTwoIds("PsrContact", this.consultantId, "GetContactInfo", contactId);
                this.fullName = info.firstName + " " + info.lastName;
                this.$refs.modalRef.open();
            },
            async deleteUser() {
                let result = await api.post("PsrContact", `${this.consultantId}/removeContact/${this.contactId}`, {contactId: this.contactId});
                if (result) {
                    this.$refs.modalRef.close();
                    this.$bus.$emit(this.$bus.$AcEvents.CONTACT_CHANGE, result);
                }
            }
        }
    }
</script>

<style scoped>

</style>